// extracted by mini-css-extract-plugin
module.exports = {"root":"RouteList_root__CdZxi","_routes":"RouteList__routes__MP9TR","_label":"RouteList__label__GpyAK"};